import React, { useEffect, useState } from "react";
import "./Navbar.scss";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setSidebarOn } from "../../store/sidebarSlice";
import { getAllCategories } from "../../store/categorySlice";
import {
  getAllCarts,
  getCartItemsCount,
  getCartTotal,
} from "../../store/cartSlice";
import {
  getAllfavorites,
  getfavoriteItemsCount,
  getfavoriteTotal,
} from "../../store/favoriteSlice";

const Navbar = () => {
  const dispatch = useDispatch();
  const categories = useSelector(getAllCategories);
  const carts = useSelector(getAllCarts);
  const itemsCount = useSelector(getCartItemsCount);
  const favorites = useSelector(getAllfavorites);
  const itemsCounts = useSelector(getfavoriteItemsCount);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  const handleSearchTerm = (e) => {
    e.preventDefault();
    setSearchTerm(e.target.value);
  };

  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Vérifie la taille à l'initialisation
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(getCartTotal());
    dispatch(getfavoriteTotal());
  }, [dispatch, carts, favorites]);

  return (
    <nav className="navbar">
      <div className="navbar-cnt flex align-center">
        <div className="brand-and-toggler flex align-center">
          <button
            type="button"
            className="sidebar-show-btn text-white"
            onClick={() => dispatch(setSidebarOn())}
          >
            <i className="fas fa-bars"></i>
          </button>
          <Link to="/" className="navbar-brand flex align-center">
            <span className="navbar-brand-ico">
              <i className="fa-solid fa-home"></i>
            </span>
            {!isMobile && (
              <span className="navbar-brand-txt mx-2">
                <span className="fw-7">LPA</span>.
              </span>
            )}
          </Link>
        </div>

        <div className="navbar-collapse w-100">
          <div className="navbar-search bg-white">
            <div className="flex align-center">
              <input
                type="text"
                className="form-control fs-14"
                placeholder="Search your preferred items here"
                onChange={(e) => handleSearchTerm(e)}
              />
              <Link
                to={`search/${searchTerm}`}
                className="text-white search-btn flex align-center justify-center"
              >
                <i
                  className={`fa-solid ${
                    isMobile ? "fa-search" : "fa-magnifying-glass"
                  }`}
                ></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="navbar-cart flex align-center">
          <Link to="/favorite" className="cart-btn">
            <i className="fa-solid fa-heart"></i>
            <div className="cart-items-value">{itemsCounts}</div>
          </Link>
        </div>

        <div className="navbar-cart flex align-center">
          <Link to="/cart" className="cart-btn">
            <i className="fa-solid fa-cart-shopping"></i>
            <div className="cart-items-value">{itemsCount}</div>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
